import configDb from "../config";
import Axios from "axios";
import { decryptData } from "./crypto";

class Utils {
  static setInt = null;
  static getErrorMessage(err) {
    let error = "Oops...something went wrong.";
    if (err.response && err.response.data) {
      if (err.response.data.data) {
        let decryptError = decryptData(err.response.data.data);
        error = decryptError.message;
        if (
          decryptError.message ===
          "Validation failed. One or more validation errors occurred."
        ) {
          decryptError?.errors?.forEach((errItem) => {
            error = errItem.msg;
          });
        }
      }
    } else if (err.message) {
      error = err.message;
    }
    return error;
  }

  static setDetail(data) {
    data = JSON.stringify(data);
    localStorage.setItem(configDb.login_data, data);
  }

  static setIntervalRemove() {
    this.setInt = setInterval(
      () => {
        localStorage.clear();
      },
      1000 * 60 * 60 * 24,
    );
  }

  static removeSetInterval() {
    if (this.setInt) clearTimeout(this.setInt);
  }

  static loginDetail() {
    const data = localStorage.getItem(configDb.login_data);
    if (data) {
      return JSON.parse(data);
    } else {
      return {};
    }
  }

  static getPermissionName(path) {
    let split = path.split("/");
    let name = "";
    if (split.length === 2) {
      name = "view_" + split[1].replace("-", "_");
    } else if (split.length > 2) {
      name = "modify_" + split[1].replace("-", "_");
    }
    return name;
  }

  static getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  static focusError() {
    setTimeout(function () {
      const errorInputs = document.getElementsByClassName("input-error");
      if (errorInputs.length > 0) {
        const firstErrorInput = errorInputs[0];
        const scrollPosition =
          firstErrorInput.getBoundingClientRect().top + window.scrollY - 100;
        window.scrollTo({ top: scrollPosition, behavior: "smooth" });
        firstErrorInput.focus();
      }
    }, 0);
  }
}

export default Utils;
